import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { PageShell, goldButton } from '../components/PageShell';
import { orderApi } from '../lib/orderApi';

const OrderSuccess = () => {
  const loc = useLocation();
  const navigate = useNavigate();
  const sessionId = new URLSearchParams(loc.search).get('session_id');
  const [status, setStatus] = useState('checking'); // checking | paid | error | timeout
  const [orderId, setOrderId] = useState(null);
  const [deliveryLabel, setDeliveryLabel] = useState('');
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    let active = true;
    const poll = async () => {
      if (attempts.current >= 8) { if (active) setStatus('timeout'); return; }
      attempts.current += 1;
      try {
        const { data } = await orderApi.get(`/orders/payment-status/${sessionId}`);
        if (!active) return;
        setOrderId(data.order_id);
        if (data.delivery_label) setDeliveryLabel(data.delivery_label);
        if (data.payment_status === 'paid') { setStatus('paid'); localStorage.removeItem('yamauchi_cart'); localStorage.removeItem('yamauchi_delivery'); return; }
        setTimeout(poll, 2000);
      } catch {
        if (active) setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <PageShell>
      <div className="mx-auto text-center" style={{ maxWidth: '520px', paddingTop: '40px' }}>
        {status === 'checking' && (
          <>
            <h1 className="font-display" style={{ fontSize: '34px', fontWeight: 700 }}>Confirmando tu pago…</h1>
            <p className="font-body mt-3" style={{ fontSize: '14px', color: '#C2C1B6' }}>Un momento, estamos verificando la transacción.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <div className="mx-auto mb-6 flex items-center justify-center" style={{ width: '64px', height: '64px', border: '1px solid #C9A84C', color: '#C9A84C', fontSize: '32px' }}>✓</div>
            <h1 className="font-display" style={{ fontSize: '34px', fontWeight: 700 }}>¡Pago confirmado!</h1>
            <p className="font-body mt-3" style={{ fontSize: '14px', color: '#C2C1B6', lineHeight: 1.7 }}>
              Tu pedido fue recibido. Te enviamos un recibo por email. Puedes seguir el estado de tu pedido.
            </p>
            {deliveryLabel && (
              <div className="mt-5 mx-auto" style={{ maxWidth: '420px', background: '#141414', border: '1px solid #C9A84C', padding: '16px' }} data-testid="delivery-label">
                <p className="font-body uppercase" style={{ fontSize: '10px', letterSpacing: '2px', color: '#C9A84C' }}>Día de entrega</p>
                <p className="font-display mt-1" style={{ fontSize: '18px', fontWeight: 700, color: '#F5F5F0' }}>{deliveryLabel}</p>
              </div>
            )}
            <div className="mt-7 flex gap-3 justify-center">
              {orderId && (
                <button onClick={() => navigate(`/pedido/${orderId}`)} style={goldButton} data-testid="track-order-btn">Seguir mi pedido</button>
              )}
            </div>
          </>
        )}
        {(status === 'error' || status === 'timeout') && (
          <>
            <h1 className="font-display" style={{ fontSize: '30px', fontWeight: 700 }}>Estamos verificando tu pago</h1>
            <p className="font-body mt-3" style={{ fontSize: '14px', color: '#C2C1B6', lineHeight: 1.7 }}>
              Si completaste el pago, tu pedido aparecerá en &quot;Mis Pedidos&quot; en breve.
            </p>
            <div className="mt-6"><Link to="/mis-pedidos" style={goldButton} data-testid="go-orders">Ver mis pedidos</Link></div>
          </>
        )}
      </div>
    </PageShell>
  );
};

export default OrderSuccess;
